import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import { format } from "date-fns";

import MillstageDropDownFilter from "../../../components/FilterBox/Millstage/MillstageDropDownFilter";
import MillstageFilterBox from "../../../components/FilterBox/Millstage/MillstageFilter";
import { FiMenu } from "react-icons/fi";

import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { Loader } from "../../../components/Loader/Loader";
import MillstageTable from "../../../components/Tables/MillstageTable";
import {
  GrpPartyDtlReport,
  GrpPartyDtlReportFun,
  StageFilters,
} from "../../../Redux/Slice/Millstage/MillstageSlice";
import Calendar from "react-calendar";
import { useTheme } from "../../../Themecontext/Themecontext";
import MillStageCelender from "../../../components/Calendar/MillstageCelender";

export const GroupWisePartyWiseDetailReport = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StageFiltersdata, GrpPartyDtlReportdata } = useSelector(
    (state) => state.MillstageSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWMILLSTAGE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWMILLSTAGEDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");

  // Production Group
  const [productionGroup, setProductionGroup] = useState("");
  const [productionGroupId, setProductionGroupId] = useState([]);

  // Stage Group
  const [stageGroup, setStageGroup] = useState("");
  const [stageGroupId, setStageGroupId] = useState([]);

  // Party Name
  const [partyName, setPartyName] = useState("");
  const [partyNameId, setPartyNameId] = useState([]);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return "";
    return format(new Date(date), "yyyy-MM-dd");
  };
  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  function formatToDDMMYYYY(date) {
    if (!date) return "";
    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const [filter, setFilter] = useState({
    productionGroup: [],
    stageGroup: [],
    partyName: [],
  });

  const [search, setSearch] = useState({
    productionGroup: "",
    stageGroup: "",
    partyName: "",
  });


  const isApiCalled = useRef(false);

  useEffect(() => {
    if (!startDate || !endDate) return;
    if (isApiCalled.current) return;

    isApiCalled.current = true;
    dispatch(StageFilters());
    dispatch(
      GrpPartyDtlReport({
        GroupIds: filter.productionGroup.join(","),
        StageIds: filter.stageGroup.join(","),
        PartyIds: filter.partyName.join(","),
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );
  }, [dispatch, startDate, endDate]);
  const productionGroupList =
    StageFiltersdata?.ProdGrp?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];

  const stageGroupList =
    StageFiltersdata?.Stage?.map((item) => ({
      label: item?.StageName,
      value: item?.StageID,
    })) || [];

  const partyNameList =
    StageFiltersdata?.Ac?.map((item) => ({
      label: item?.ACName,
      value: item?.AcID,
    })) || [];

  // 🔷 Date
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const handleSubmit = () => {
    dispatch(GrpPartyDtlReportFun());

    dispatch(
      GrpPartyDtlReport({
        GroupIds: filter.productionGroup.join(","),
        StageIds: filter.stageGroup.join(","),
        PartyIds: filter.partyName.join(","),
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );

    setShowFilter(false)
  };

  const handleSubmit1 = () => {
    dispatch(GrpPartyDtlReportFun());

    dispatch(
      GrpPartyDtlReport({
        GroupIds: productionGroupId.join(","),
        StageIds: stageGroupId.join(","),
        PartyIds: partyNameId.join(","),
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );
  };
  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const columns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Date",
      key: "Date",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "ChalanNo",
      key: "ChalanNo",
      align: "right",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "LotNo",
      key: "LotNo",
      align: "right",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "QualityType",
      key: "QualityType",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Taka", key: "Taka", align: "right", format: "true" },
    { label: "JET M/C", key: "JETM/C", align: "left" },
    { label: "DRUM M/c", key: "DRUMM/c" },
    { label: "DeliveryDate", key: "DeliveryDate", align: "left" },
  ];

  const rows = (GrpPartyDtlReportdata?.Data || []).map((row) => ({
    Date: formatToDDMMYYYY(row?.Date),
    ChalanNo: row?.ChalanNo,
    LotNo: row?.LotNo,
    QualityType: row?.QualityType,
    Taka: row?.Taka,
    Meter: row?.Meter,
    "JETM/C": row?.["JET M/C"], // property name also requires quotes
    "DRUMM/C": row?.["DRUM M/C"], // property name also requires quotes
    DeliveryDate: row?.DeliveryDate,
  }));

  if (!StageFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!GrpPartyDtlReportdata || GrpPartyDtlReportdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }
  return (
    <div
      style={{
        background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
        minHeight: "100vh",
        padding: "16px",
      }}
    >

      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>
      <Offcanvas show={showFilter} onHide={handleClose} placement="start"
        style={{
          background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }}
        >
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Col style={{ flex: 1 }}>
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour7,
                    padding: "13px 20px",
                    borderRadius: "12px 12px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6}`,
                    padding: "15px",
                    marginBottom: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour9,
                    borderRadius: "0px 0px 12px 12px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6}`,
                      borderRadius: "10px",
                      cursor: "pointer",
                      textAlign: "center",
                      color:
                        isdark === "light"
                          ? iscolour?.Colour11
                          : iscolourDark?.Colour1,
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
            </Col>
            <MillstageFilterBox
              title="Production Group"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filter.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />

            <MillstageFilterBox
              title="Stage Group"
              items={stageGroupList}
              search={search.stageGroup}
              setSearch={(val) => handleSearch("stageGroup", val)}
              selectedItems={filter.stageGroup}
              toggleItem={(item) => toggleItem("stageGroup", item)}
              selectAll={() => selectAll("stageGroup", stageGroupList)}
            />

            <MillstageFilterBox
              title="Party Name"
              items={partyNameList}
              search={search.partyName}
              setSearch={(val) => handleSearch("partyName", val)}
              selectedItems={filter.partyName}
              toggleItem={(item) => toggleItem("partyName", item)}
              selectAll={() => selectAll("partyName", partyNameList)}
            />
            <Button
              onClick={handleSubmit}
              style={{
                width: "100%",
                // height: "44px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour4,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                border: "none",
                fontWeight: "700",
                padding: "12px"
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour10,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7
            }`,
        }}
      >
        <Row className="g-2 align-items-end ">
          {/* DATE */}
          <Col xl={3} lg={6}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span
                style={{
                  color:
                    isdark === "light"
                      ? iscolour?.Colour9
                      : iscolourDark?.Colour1,
                  fontWeight: "700",
                  fontSize: "13px",
                }}
              >
                Date Range
              </span>
            </div>
            <div
              onClick={() => setShowDatePicker(true)}
              style={{
                marginTop: "8px",
                padding: "10px",
                // border: `2px solid ${
                //   isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6
                // }`,
                borderRadius: "12px",
                cursor: "pointer",
                textAlign: "center",
                border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6}`,
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color:
                  isdark === "light" ? iscolour?.Colour : iscolourDark?.Colour1,
              }}
            >
              {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                : "Select Date Range"}
            </div>
          </Col>

          <Col xl={3} lg={6}>
            <MillstageDropDownFilter
              label="Production Group"
              data={productionGroupList}
              selectedValue={productionGroup}
              setSelectedValue={setProductionGroup}
              selectedId={productionGroupId}
              setSelectedId={setProductionGroupId}
              placeholder="Select Production Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          <Col xl={3} lg={6}>
            <MillstageDropDownFilter
              label="Stage Group"
              data={stageGroupList}
              selectedValue={stageGroup}
              setSelectedValue={setStageGroup}
              selectedId={stageGroupId}
              setSelectedId={setStageGroupId}
              placeholder="Select Stage Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          <Col xl={3} lg={6}>
            <MillstageDropDownFilter
              label="Party Name"
              data={partyNameList}
              selectedValue={partyName}
              setSelectedValue={setPartyName}
              selectedId={partyNameId}
              setSelectedId={setPartyNameId}
              placeholder="Select Party Name"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* BUTTON */}
          <Col xl={12} lg={12} md={12} sm={12}>
            <button
              onClick={handleSubmit1}
              style={{
                padding: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour4,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                // height: "45px",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          MACHINE GROUPWISE DETAILS
        </div>

        <MillstageTable columns={columns} data={rows} />
      </div>

      {/* 🔷 DATE PICKER MODAL */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <MillStageCelender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour10,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GroupWisePartyWiseDetailReport;
